export const stripePayoutExplainer =
  "Other ways to pay, like cash, checks, or payment apps, do not give MyTeenGig a reliable way to confirm that a teen was paid. "
  + "Stripe gives MyTeenGig a documented payout flow: the gig, the agreed amount, collected funds, and payout release after completion stay in one place.";
